import { Grid, TextField, Typography } from "@mui/material"
import { PatternFormat, PatternFormatProps } from "react-number-format"
import { phoneFormats } from "../../Types/General";

interface KaziPhoneNumberProps extends PatternFormatProps<any> {
    format: string;
    showLabel?: boolean;
}
export const KaziPhoneNumber = (props:KaziPhoneNumberProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const format  = phoneFormats.find( format => format.label === props.format)?.value ?? '##################'
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={'flex'} flexDirection={'column'} width={'100%'} flex={1}>
            {props.showLabel && <Typography variant='body-small' color={'black.200'} marginBottom={1}>Phone number</Typography>}
            <PatternFormat
                {...props}
                customInput={TextField}
                format={format}
                allowEmptyFormatting
                placeholder="Phone number"
            /> 
        </Grid>
    )
}